module.exports = __webpack_public_path__ + "img/menu_schedule_green_icon.02a6ed41.svg";